import AsteroidField from "./includes/js2-asteroids";

function init() {

    // console.log( 'Homepage Takeover', { 'asteroids': document.querySelectorAll('[data-component-asteroids]') });
    // asteroids
    document.querySelectorAll('[data-component-asteroids]').forEach((element) => {
        new AsteroidField(element, {
            movement: {
                foreground: {
                    scale: 2.4,
                    floatMovement: 1.2,
                },
                midground: {
                    scale: 1.6,
                    floatMovement: 0.8,
                },
                background: {
                    scale: 0.8,
                    floatMovement: 0.4
                },
            },
        });
    });

}

// Run when the DOM is ready
// Check if `window.onload` has already fired
if (document.readyState === 'complete') {
    init(); // Page is already fully loaded, run immediately
} else {
    window.addEventListener('load', init); // Otherwise, wait for `window.onload`
}